import { BLOG_COVER_PLACEHOLDER_SRC } from './blogConstants';

/**
 * Валиден `src` за корица в блога (Next/Image не трябва да получава празен низ).
 * @param {unknown} url
 * @returns {string}
 */
export function resolveBlogCoverSrc(url) {
  const t = typeof url === 'string' ? url.trim() : '';
  return t || BLOG_COVER_PLACEHOLDER_SRC;
}

/**
 * Параграфи от plain text.
 * - Първо: двоен нов ред = нов абзац (класически markdown-блок).
 * - Ако целият текст е в един блок, но има единични нови редове — режем по тях,
 *   за да не „изчезва“ съдържание от админ/редактор без празен ред между абзаци.
 * @param {string} text
 * @returns {string[]}
 */
export function splitContentToParagraphs(text) {
  if (!text) {
    return [];
  }
  const raw = String(text).trim();
  if (!raw) {
    return [];
  }
  let parts = raw
    .split(/\n\s*\n+/)
    .map((p) => p.trim())
    .filter(Boolean);
  if (parts.length === 1 && /\r?\n/.test(parts[0])) {
    parts = parts[0]
      .split(/\r?\n/)
      .map((p) => p.trim())
      .filter(Boolean);
  }
  return parts.length > 0 ? parts : [raw];
}

/**
 * Кратко описание за карти / meta fallback (без HTML).
 * @param {string} text
 * @param {number} maxLen
 */
export function truncatePlainText(text, maxLen = 180) {
  const singleLine = String(text || '')
    .replace(/\s+/g, ' ')
    .trim();
  if (singleLine.length <= maxLen) {
    return singleLine;
  }
  const cut = singleLine.slice(0, maxLen - 1).trimEnd();
  const lastSpace = cut.lastIndexOf(' ');
  const wordSafe = lastSpace > 40 ? cut.slice(0, lastSpace) : cut;
  return `${wordSafe}…`;
}

/**
 * Meta description до ~160 символа (препоръка Google).
 * @param {string} text
 */
export function truncateForMetaDescription(text, maxLen = 160) {
  return truncatePlainText(text, maxLen);
}

/** Кратка дата bg-BG за карти, релси и страница на статия. */
export function formatBlogPublishShort(iso) {
  if (!iso) {
    return '';
  }
  try {
    return new Date(iso).toLocaleDateString('bg-BG', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  } catch {
    return '';
  }
}

/** Дали `truncatePlainText` е добавил многоточие в края. */
export function endsWithTruncationEllipsis(s) {
  const t = String(s || '');
  return /\u2026$/.test(t) || /\.\.\.$/.test(t);
}

/** Премахва финалното многоточие от truncate (за ръчно „ … “ + линк в картата). */
export function stripTruncationEllipsis(s) {
  return String(s || '')
    .replace(/(\u2026|\.\.\.)\s*$/u, '')
    .trimEnd();
}
